export default __webpack_public_path__ + "static/media/tokoramePoin.b9cb9cae.png";